module.exports = __webpack_public_path__ + "static/img/company_news05.9c2ed97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutMe/company_news05.jpg
// module id = 6grV
// module chunks = 2